module.exports = __webpack_public_path__ + "static/media/6-.aa81a997.webp";